/* eslint-disable unicorn/prefer-string-slice */
import React, { useMemo } from 'react';
import { Container } from './circle-styles';
import { getDiameter } from '../utils';
var Circle = function (_a) {
    var radius = _a.radius, fillColor = _a.fillColor, children = _a.children, padding = _a.padding, margin = _a.margin;
    var diameter = useMemo(function () { return getDiameter(radius); }, [radius]);
    return (React.createElement(Container, { fillColor: fillColor, diameter: diameter, padding: padding, margin: margin }, children));
};
export default Circle;
